export default "__VITE_ASSET__Big1LKLN__"